export default __webpack_public_path__ + "static/media/12-Inch-Planter-Wall-Sand-Stone-Mocha.51817611.jpg";